import { SET_IMPORTUSER } from '../actions';

const userimport = (state = [], action) => {
  switch (action.type) {
	case SET_IMPORTUSER:
      return [...action.value];  
    default: return state;
  }
}

export default userimport;
